import {
  Box,
  Button,
  CloseButton,
  Dialog,
  Input,
  Portal,
  Text,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { isValidEmail } from "../helpers";

export function EmailModal({
  open,
  loading = false,
  onConfirm,
  onClose,
}: {
  open: boolean;
  loading?: boolean;
  onConfirm: (email: string) => void;
  onClose: () => void;
}) {
  const [email, setEmail] = useState("");
  const [error, setError] = useState<string | undefined>();

  useEffect(() => {
    if (!open) {
      setEmail("");
      setError(undefined);
    }
  }, [open]);

  const handleConfirm = () => {
    if (loading) return;
    const trimmed = email.trim();
    if (!trimmed) {
      setError("El correo es requerido");
      return;
    }
    if (!isValidEmail(trimmed)) {
      setError("Ingresa un correo válido");
      return;
    }
    setError(undefined);
    onConfirm(trimmed);
  };

  const handleClose = () => {
    if (loading) return;
    onClose();
  };

  return (
    <Dialog.Root
      open={open}
      onOpenChange={(details) => {
        if (!details.open) handleClose();
      }}
    >
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content maxW="440px">
            <Dialog.Header borderBottom="1px solid" borderColor="gray.100">
              <Dialog.Title fontSize="lg" fontWeight="bold">
                Correo del administrador
              </Dialog.Title>
              <Dialog.CloseTrigger asChild>
                <CloseButton
                  size="sm"
                  onClick={handleClose}
                  disabled={loading}
                />
              </Dialog.CloseTrigger>
            </Dialog.Header>
            <Dialog.Body px={6}>
              <Text fontSize="sm" color="gray.600" lineHeight="tall">
                Con este correo te avisaremos sobre el estado de tu solicitud y,
                una vez creado tu comercio, será el usuario administrador que
                podrá gestionar la configuración en Palomma.
              </Text>
              <Box spaceY={1.5}>
                <Text fontSize="sm" fontWeight="medium" color="gray.700">
                  Correo electrónico
                </Text>
                <Input
                  type="email"
                  value={email}
                  disabled={loading}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    if (error) setError(undefined);
                  }}
                  placeholder="tucorreo@ejemplo.com"
                  onKeyDown={(e) => e.key === "Enter" && handleConfirm()}
                />
                {error && (
                  <Text fontSize="xs" color="red.500">
                    {error}
                  </Text>
                )}
              </Box>
            </Dialog.Body>
            <Dialog.Footer
              borderTop="1px solid"
              borderColor="gray.100"
              p={6}
              gap={3}
            >
              <Button variant="ghost" onClick={handleClose} disabled={loading}>
                Cancelar
              </Button>
              <Button
                colorPalette="palomma"
                onClick={handleConfirm}
                disabled={loading}
                loading={loading}
              >
                Continuar
              </Button>
            </Dialog.Footer>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
}
